export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Social Planer',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Website',
        mediaLibrary: 'Mediathek',
        email: 'E-Mail',
        words: 'Wörter',
        variations: 'Variationen',
        thisIsPaidService: 'Diese Funktion ist ein kostenpflichtiger Service und es können Kosten gemäß Ihrer Nutzung anfallen',
        all: 'Alle',
    },
};
